import {
    Badge,
    Group,
    Paper,
    Text,
} from '@mantine/core';

import {ObservationSummary} from '../utils/buildCascades';

// The answer to "where are the errors / what is broken", stated before the table.
// The counts are deliberately ordered by what a triager should act on:
//   Failed             -> real defects
//   Passed, unrecorded -> the platform didn't record a working interaction
//   Blocked            -> consequences, shown so the number is not mistaken for defects
//   Not implemented    -> build status, not breakage
export const TriageSummary = ({summary}: { summary: ObservationSummary }) => {

    const entries: { label: string, value: number, color: string, hint: string }[] = [
        {
            label: 'Failed',
            value: summary.failed,
            color: 'red',
            hint: 'Real defects.',
        },
        {
            label: 'Passed, not recorded',
            value: summary.passedUnverified,
            color: 'orange',
            hint: 'The action worked but the platform did not record it.',
        },
        {
            label: 'Blocked',
            value: summary.blocked,
            color: 'gray',
            hint: 'Skipped because something upstream failed — consequences, not defects.',
        },
        {
            label: 'Not implemented',
            value: summary.unimplemented,
            color: 'blue',
            hint: 'No handler built yet — build status, not breakage.',
        },
    ];

    return (
        <Paper withBorder p={'md'} radius={'md'}>
            <Group justify={'space-between'} align={'center'} wrap={'wrap'}>
                <Group gap={'lg'} wrap={'wrap'}>
                    {entries.map((entry) => (
                        <Group key={entry.label} gap={'xs'} title={entry.hint}>
                            <Badge
                                color={entry.color}
                                variant={entry.value > 0 ? 'filled' : 'light'}
                                size={'lg'}
                            >
                                {entry.value}
                            </Badge>
                            <Text size={'sm'} c={entry.value > 0 ? undefined : 'dimmed'}>
                                {entry.label}
                            </Text>
                        </Group>
                    ))}
                </Group>
                <Text size={'sm'} c={'dimmed'}>{`${summary.total} observations in view`}</Text>
            </Group>
        </Paper>
    );
};
